import React, { useState, useEffect } from 'react';
import classes from './details.module.css';
import WhiteArrow from "../../../../assets/images/double-arrow.png";
import InputField from '../../../containers/inputField/inputField';
import { sixYardAxios } from '../../../../sixYardAxios';
import PromptMessage from '../../../containers/promptMessage/promptMessage';

const Details = (props) => {
    const isEnglish = parseInt(localStorage.getItem('language')) === 1;
    
    const generateYearOptions = () => {
        const currentYear = new window.Date().getFullYear();
        const years = [];
        for (let year = 2006; year <= currentYear; year++) {
            years.push({ value: year, displayValue: year });
        }
        return years;
    };
    const locationsList = props.academy?.locations?.map(location => ({
        value: location.id,
        displayValue: location.name,
    })) || [];
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [locationName, setLocationName] = useState(props.selectedLocation?.name.split("Pack")[0]?.toLowerCase().trim() || "")
    const [selectedLocation, setSelectedLocation] = useState({
        location: {
            elementType: "select",
            elementConfig: {
                type: "select",
                placeholder: isEnglish ? "Choose location" : "اختر الموقع",
                options: locationsList
            },
            value: props.selectedLocation?.id || "",
            validation: {
                required: true,
            },
            label: isEnglish ? "Pack" : "الباقة",
            valid: false,
            touched: false
        }
    });
    const [selectedInterval, setSelectedInterval] = useState(props.selectedPlan);
    // const [askForReferee, setAskForReferee] = useState(false);
    const [dateControls, setDateControls] = useState({
        selectedDate: {
            withIcon: true,
            elementType: "input",
            elementConfig: {
                type: "calendarDate",
                placeholder: isEnglish ? "Select date" : "اختر التاريخ",
            },
            value: "",
            validation: {
                required: true,
            },
            label: isEnglish ? "Starting Date" : "تاريخ البدء",
            valid: false,
            touched: false
        },
    });
    const [controls, setControls] = useState({
        kidsName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: isEnglish ? "Enter name" : "أدخل الاسم",
            },
            value: "",
            validation: {
                required: true,
                minLength: 6,
                maxLength: 32,
            },
            label: isEnglish ? "Kid's Full Name" : "الاسم الكامل للطفل",
            valid: false,
            touched: false
        },
        yearOfBirth: {
            elementType: "select",
            elementConfig: {
                type: "select",
                placeholder: isEnglish ? "Select year" : "اختر السنة",
                options: generateYearOptions()
            },
            value: "",
            validation: {
                required: true,
            },
            label: isEnglish ? "Birth Year" : "سنة الميلاد",
            valid: false,
            touched: false
        },
        startingTime: {
            elementType: "select",
            elementConfig: {
                type: "text",
                placeholder: isEnglish ? "Select time" : "اختر الوقت",
                options: [
                    { value: "10:00", displayValue: "10:00 AM" },
                    { value: "12:00", displayValue: "12:00 PM" },
                    { value: "14:00", displayValue: "02:00 PM" },
                    { value: "16:00", displayValue: "04:00 PM" },
                    { value: "18:00", displayValue: "06:00 PM" }
                ]
            },
            value: "",
            validation: {
                required: false,
            },
            label: isEnglish ? "Class Time" : "وقت الصف",
            valid: true,
            touched: false,
            hidden: true
        }
    });
    const [personalInfo, setPersonalInfo] = useState({
        email: {
            elementType: "input",
            elementConfig: {
                type: "email",
                placeholder: isEnglish ? "Enter email" : "أدخل البريد الإلكتروني",
            },
            value: "",
            label: isEnglish ? "Email" : "البريد الإلكتروني",
            validation: {
                required: true,
                isEmail: true
            },
            valid: false,
            touched: false
        },
        phone: {
            elementType: "input",
            elementConfig: {
                type: "phone",
                placeholder: "07xxxxxxxx",
                options: []
            },
            value: "",
            valueName: "phone_number",
            validation: {
                required: true,
                isNumeric: true
            },
            label: isEnglish ? "Phone Number" : "رقم الهاتف",
            valid: false,
            touched: false
        },
    })
    
    useEffect(() => {
        const newIsEnglish = parseInt(localStorage.getItem('language')) === 1;
        
        setSelectedLocation(prev => ({
            location: {
                ...prev.location,
                elementConfig: {
                    ...prev.location.elementConfig,
                    placeholder: newIsEnglish ? "Choose location" : "اختر الموقع",
                },
                label: newIsEnglish ? "Pack" : "الباقة",
            }
        }));
        
        setDateControls(prev => ({
            selectedDate: {
                ...prev.selectedDate,
                elementConfig: {
                    ...prev.selectedDate.elementConfig,
                    placeholder: newIsEnglish ? "Select date" : "اختر التاريخ",
                },
                label: newIsEnglish ? "Starting Date" : "تاريخ البدء",
            }
        }));
        
        setControls(prev => ({
            kidsName: {
                ...prev.kidsName,
                elementConfig: {
                    ...prev.kidsName.elementConfig,
                    placeholder: newIsEnglish ? "Enter name" : "أدخل الاسم",
                },
                label: newIsEnglish ? "Kid's Full Name" : "الاسم الكامل للطفل",
            },
            yearOfBirth: {
                ...prev.yearOfBirth,
                elementConfig: {
                    ...prev.yearOfBirth.elementConfig,
                    placeholder: newIsEnglish ? "Select year" : "اختر السنة",
                },
                label: newIsEnglish ? "Birth Year" : "سنة الميلاد",
            },
            startingTime: {
                ...prev.startingTime,
                elementConfig: {
                    ...prev.startingTime.elementConfig,
                    placeholder: newIsEnglish ? "Select time" : "اختر الوقت",
                },
                label: newIsEnglish ? "Class Time" : "وقت الصف",
            }
        }));
        
        setPersonalInfo(prev => ({
            email: {
                ...prev.email,
                elementConfig: {
                    ...prev.email.elementConfig,
                    placeholder: newIsEnglish ? "Enter email" : "أدخل البريد الإلكتروني",
                },
                label: newIsEnglish ? "Email" : "البريد الإلكتروني",
            },
            phone: {
                ...prev.phone,
                label: newIsEnglish ? "Phone Number" : "رقم الهاتف",
            }
        }));
    }, [localStorage.getItem('language')]);
    
    useEffect(() => {
        const updatedControls = {
            ...selectedLocation,
            location: {
                ...selectedLocation.location,
                elementConfig: {
                    ...selectedLocation.location.elementConfig,
                    options: props.academy?.locations?.map(type => ({
                        value: type.id,
                        displayValue: type.name,
                    })) || [],
                },
            },
        };
        setSelectedLocation(updatedControls);
    }, [props.academy?.locations]);
    const formElementsArray = [];
    for (let key in controls) {
        if (!controls[key].hidden) {
            formElementsArray.push({
                id: key,
                config: controls[key]
            });
        }
    }
    const form = formElementsArray.map((formElement, i) => (
        <div key={i} className={classes.FormGroup}>
            <InputField
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                withRemove={false}
                withIcon={formElement.config.withIcon}
                label={formElement.config.label}
                changed={event => inputChangedHandler(event, formElement.id, setControls, controls)}
            />
        </div>
    ));
    const personalFormElementsArray = [];
    for (let key in personalInfo) {
        personalFormElementsArray.push({
            id: key,
            config: personalInfo[key]
        });
    }
    const personal = personalFormElementsArray.map((formElement, i) => (
        <div key={i} className={classes.FormGroup}>
            <InputField
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                withRemove={false}
                withIcon={formElement.config.withIcon}
                label={formElement.config.label}
                changed={event => inputChangedHandler(event, formElement.id, setPersonalInfo, personalInfo)}
            />
        </div>
    ));
    const checkValidity = ((value, rules) => {
        let isValid = true;
        if (!rules) {
            return true;
        }

        if (rules.required) {
            value = typeof value === 'string' ? value.trim() : value;
            isValid = value !== "" && isValid;
        }

        if (rules.minLength) {
            isValid = value?.length >= rules.minLength && isValid;
        }

        if (rules.maxLength) {
            isValid = value?.length <= rules.maxLength && isValid;
        }

        if (rules.isEmail) {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test(value) && isValid;
        }

        if (rules.isNumeric) {
            const pattern = /^\d+$/;
            isValid = pattern.test(value) && isValid;
        }

        return isValid;
    })
    const inputChangedHandler = (event, controlName, controlFunction, state) => {
        const value = (controlName === 'selectedDate' || controlName === 'phone') ? event : event.target.value;
        const updatedControls = {
            ...state,
            [controlName]: {
                ...state[controlName],
                value,
                valid: checkValidity(value, state[controlName].validation),
                touched: true
            }
        };
        controlFunction(updatedControls);
        if (controlName === 'location') {
            const newSelectedLocation = (props.academy?.locations?.filter((location) => location.id == updatedControls.location.value))?.[0]
            props.setSelectedLocation(newSelectedLocation)
            setLocationName(newSelectedLocation.name?.split("Pack")[0]?.toLowerCase().trim())
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const formData = {
                location_id: selectedLocation.location.value,
                interval_id: selectedInterval.id,
                starting_date: dateControls.selectedDate.value[0],
                kid_name: controls.kidsName.value,
                birth_year: controls.yearOfBirth.value,
                email: personalInfo.email.value,
                phone: personalInfo.phone.value?.dialCode + personalInfo.phone.value?.number,
                terms_accepted: isTermsChecked
            }
            const response = await sixYardAxios.post('/academy/register', formData);
            if (response.data.data) {
                props.setRegistrationId(response.data.data?.registration_id);
                props.setBookingData(response.data.data?.booking_summary);
                localStorage.setItem("academyRegistrationFormStudent", JSON.stringify(formData));
                props.setCurrentStep(props.currentStep + 1);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    const Date = <div className={[classes.FormGroup, classes.FormGroupCalendar].join(" ")}> <InputField
        elementType={dateControls.selectedDate.elementType}
        elementConfig={dateControls.selectedDate.elementConfig}
        value={dateControls.selectedDate.value}
        invalid={!dateControls.selectedDate.valid}
        shouldValidate={dateControls.selectedDate.validation}
        touched={dateControls.selectedDate.touched}
        withIcon={dateControls.selectedDate.withIcon}
        label={dateControls.selectedDate.label}
        changed={event => inputChangedHandler(event, "selectedDate", setDateControls, dateControls)} /></div>
    return (
        <>
            <form className={classes.Container} onSubmit={handleSubmit}>
                <div className={classes.SectionTitle}>
                    {isEnglish ? "Pack & Date" : "الباقة والتاريخ"}
                </div>
                <div className={classes.Field}>
                    <InputField
                        elementType={selectedLocation.location.elementType}
                        elementConfig={selectedLocation.location.elementConfig}
                        value={selectedLocation.location.value}
                        invalid={!selectedLocation.location.valid}
                        shouldValidate={selectedLocation.location.validation}
                        touched={selectedLocation.location.touched}
                        withRemove={false}
                        withIcon={selectedLocation.location.withIcon}
                        label={selectedLocation.location.label}
                        changed={event => inputChangedHandler(event, "location", setSelectedLocation, selectedLocation)}
                    />
                </div>
                <div className={classes.Field}>
                    <label className={classes.Label}>
                        {isEnglish ? "Duration" : "المدة"} <span className={classes.Required}>*</span>
                    </label>
                    <div className={classes.RadioGroup}>{props.plans?.filter((plan) =>
                        plan.pack_type.trim() === locationName)?.map(plan =>
                            <label key={plan.id} className={selectedInterval.id === plan.id ? classes.LabelChecked : ''}>
                                <input
                                    type="radio"
                                    name="interval"
                                    id={plan.id}
                                    value={plan.id}
                                    checked={selectedInterval.id === plan.id}
                                    onChange={() => setSelectedInterval(plan)}
                                />
                                {plan.name} {plan.discount > 0 && <span>{plan.discount}%</span>}
                            </label>)}
                    </div>
                </div>
                {Date}
                <div className={classes.SectionTitle}>
                    {isEnglish ? "Kid's Info" : "معلومات الطفل"}
                </div>
                {form}
                <div className={classes.SectionTitle}>
                    {isEnglish ? "Personal Info" : "المعلومات الشخصية"}
                </div>
                {personal}
                <div className={classes.Field}>
                    <p className={classes.Prompt}>
                        {isEnglish 
                            ? "Please read and agree to our " 
                            : "يرجى قراءة والموافقة على "}
                        <a href="/privacy-policy" target='_blank' className={classes.Link}>
                            {isEnglish ? "Privacy Policy " : "سياسة الخصوصية "}
                        </a>
                        {isEnglish ? "and " : "و "}
                        <a href="/terms-and-conditions" target='_blank' className={classes.Link}>
                            {isEnglish ? "Terms" : "الشروط"}
                        </a>
                    </p>
                    <div className={classes.CheckBox}>
                        <input type="checkbox" onClick={() => setIsTermsChecked(!isTermsChecked)} />
                        <label className={classes.Label}>
                            {isEnglish 
                                ? "I have read and agreed to terms and conditions and privacy policy"
                                : "لقد قرأت ووافقت على الشروط والأحكام وسياسة الخصوصية"}
                        </label>
                    </div>
                </div>
                <button type='submit'
                    className={[classes.Next, !isTermsChecked && classes.Disabled].join(" ")}
                    disabled={!isTermsChecked}>
                    {isEnglish ? (
                        <>NEXT <img src={WhiteArrow} alt="" className={classes.SubmitIcon} /></>
                    ) : (
                        <>التالي <img src={WhiteArrow} alt="" className={[classes.SubmitIcon, classes.ReverseIcon].join(" ")} /></>
                    )}
                </button>
            </form>
            {error && <PromptMessage 
                message={error} 
                status={isEnglish ? 'Oops' : 'عفواً'} 
                button={isEnglish ? 'CLOSE' : 'إغلاق'} 
                click={() => setError(false)} 
            />}
        </>
    );
};

export default Details;
